module.exports = __webpack_public_path__ + "aad6254f6a4cc2cb95dc7d4a9896bbd7.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/alt/score.png
// module id = 699
// module chunks = 0